// extracted by mini-css-extract-plugin
export default {"dialog":"StatusDialog_dialog__QZjN9"};